import type ModuleButtonsType from 'app/main/modules/components/ModuleButtonsType';
import { showKpisGoalsEditDialog } from './components/KpisGoalsEditDialog';

const buttons: ModuleButtonsType = {
	view: {
		headerButtons: [],
		fabs: [
			{
				id: 'goals',
				name: 'BUTTON_KPI_GOAL_NEW',
				icon: 'plus-circle',
				action: ({ dispatch, updateRefresh }) =>
					dispatch(showKpisGoalsEditDialog({ isAdd: true, updateRefresh }))
			},
			{
				id: 'goals-values',
				name: 'BUTTON_KPI_GOAL_NEW',
				icon: 'plus-circle',
				action: ({ dispatch, updateRefresh }) =>
					dispatch(showKpisGoalsEditDialog({ isAdd: true, updateRefresh }))
			}
		]
	}
};

export default buttons;
